import NAVBAR from '../../../../DOM/nav/navbar/NAVBAR.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { SVGS } from '../../../../SVG/SVGS.js';
import { button } from '../../../../DOM/button/BUTTON.js';
import { icon } from '../../../../SVG/icon/ICON.js';
import { span } from '../../../../DOM/span/SPAN.js';
// Model Structure
export const navHeaderAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const navHeaderData = makeDataStruct([
    ['label', span('')],
    ['icon', icon(SVGS.LOGO_CLAIMSECURE)],
    ['navLeft'],
    ['navCenter'],
    ['navRight']
]);
// Simplified model
export function navheader(name, className, label, icon, navLeft, navCenter, navRight) {
    return {
        attributes: navHeaderAttr(name, className),
        data: navHeaderData(label, icon, navLeft, navCenter, navRight)
    };
}
/** A NAVBAR that acts as an Element Header */
export default class NAVHEADER extends NAVBAR {
    constructor(node, model) {
        super(node, model);
        this.addClass('nav-header');
        this.btnIcon = this.navLeft.addButton(button(model.data.label, '', model.data.icon));
    }
}
